module.exports = __webpack_public_path__ + "img/image_6.5109fe85.png";